import React from "react";

const DailyDealsAds = ({
  width,
  height,
  marginLeft = 0,
  marginBottom = 0,
  data,
  borderRadius = 8,
  padding = 10,
}) => {
  return (
    <div
      className="nib-box"
      style={{
        width,
        height,
        marginLeft,
        marginBottom,
        borderRadius,
        padding,
      }}
    >
      <div style={{ position: "relative", width: `${width}` }}>
        <img
          src={
            data?.image
            // ||
            // "https://bgz-business.s3.us-east-2.amazonaws.com/FreeBusinessImage.jpg"
          }
          style={{
            width: "100%",
            objectFit: "fill",
            height: 350,
            padding: 0,
            borderRadius: 8,
            marginLeft: 0,
          }}
          alt=""
        />
      </div>
    </div>
  );
};

export default DailyDealsAds;
